import React, {useEffect} from 'react';
import defaultTheme from "./constant";

import Navbar from "./Component/Navbar";
import CardWork from "./Component/CardWork";

import SvgArrow from "./Svg/ArrowDown";
import SvgMail from "./Svg/Mail";
import SvgLinkedin from "./Svg/Linkedin";
import SvgGithub from "./Svg/Github";
import SvgPhone from "./Svg/Phone";

import imgMe from "./assets/images/me.jpg";

import SortifyDashboard from "./assets/images/Sortify/dashboard.png";
import SortifyCreate from "./assets/images/Sortify/create.png";
import SortifyHome from "./assets/images/Sortify/home.png";
import SortifySort from "./assets/images/Sortify/sort.png";
import SortifyFinish from "./assets/images/Sortify/finish.png";

import TrackapMap from "./assets/images/Trackap/Map.png"
import TrackapProfile from "./assets/images/Trackap/Profile.png"
import TrackapStatistics from "./assets/images/Trackap/Statistics.png"
import TrackapCustomisation from "./assets/images/Trackap/Customisation.png"

import LeagueOfLegends from "./assets/images/LeagueOfLegends/LeagueofLegends.jpg"

import Thesis from "./assets/images/Thesis/img.png"

import JSCMP from "./assets/images/JS-CMP/logo.png"

const Works = [
    {
        images: [Thesis],
        alts: ["Thesis"],
        title: "Mémoire de recherche",
        description: "Durant mon année à l'université de Kent, j'ai rédigé un mémoire de recherche sur la construction de graphes de connaissances temporelles pour l'évolution des marchés financiers en utilisant des modèles de langage de grande taille.",
        link: "https://hgalan.dev/University_of_Kent_Thesis.pdf",
    },
    {
        images: [SortifyHome, SortifyDashboard, SortifySort, SortifyCreate, SortifyFinish],
        alts: ["Sortify home", "Sortify dashboard", "Sortify sort", "Sortify create", "Sortify finish"],
        title: "Sortify",
        description: "Sortify est l'un de mes projet de long date. Sortify est une application web qui permet de trier ses musiques en fonction de leur genre à partir de Spotify. Il compte aujourd'hui plus de 500 utilisateurs actifs par mois.",
        link: "https://www.sortify.fr/",
        github: "https://github.com/SimonBandiera/Sortify"
    },
    {
        images: [LeagueOfLegends],
        alts: ["LeagueOfLegends"],
        title: "League of Legends Prediction",
        description: "Lors de mon année à l'université de Kent, j'ai réalisé un projet de prédiction du gagnant d'une partie de League of Legends minute par minute en utilisant des techniques de machine learning. Le modèle a atteint une précision de 75% sur un ensemble de données de 200 000 parties.",
        link: "https://github.com/YoungSnoww/LeagueOfLegendsModelBenchmark/blob/main/BenchmarkResults.md",
        github: "https://github.com/YoungSnoww/LeagueOfLegendsModelBenchmark/tree/main"
    },
    {
        images: [JSCMP],
        alts: ["JS-CMP Logo"],
        title: "JS-CMP",
        description: "JS‑CMP est un projet open‑source, co‑créé avec deux collaborateurs, qui comble le fossé entre JavaScript et C++. Son transpileur convertit le code JavaScript en C++ et le compile en exécutables haute performance, permettant aux développeurs JavaScript de bénéficier de la rapidité et de l’efficacité de C++ sans changer de langage.",
        link: "https://js-cmp.github.io/web/",
        github: "https://github.com/JS-CMP"
    },

    {
        images: [TrackapMap, TrackapStatistics, TrackapCustomisation, TrackapProfile],
        alts: ["Trackap Map", "Trackap Statistics", "Trackap Customisation", "Trackap Profile"],
        title: "Trackap",
        description: "J'ai pu travaillez en tant que développeur fullstack avec Trackap, une startup qui propose des traceurs GPS pour les vélos électriques.",
        link: "https://trackap.com/",
    }
]

function App() {
    useEffect(() => {
        window.addEventListener("scroll", () => {
            let reveals = document.querySelectorAll(".reveal");
            if (window.scrollY > 1) {
                document.querySelectorAll(".fade").forEach((e) => {
                    e.classList.add("active");
                });
            } else {
                document.querySelectorAll(".fade").forEach((e) => {
                    e.classList.remove("active");
                });
            }
            reveals.forEach((e) => {
                let windowHeight = window.innerHeight;
                let elementBottom = e.getBoundingClientRect().top;
                let elementVisible = windowHeight / 5;

                if (elementBottom < windowHeight - elementVisible) {
                    e.classList.add("active");
                    return;
                }
                e.classList.remove("active");
            });
        });
    }, []);
    return (
        <div>
            <Navbar/>
            <div className={"flex flex-col m-auto justify-around w-10/12 lg:w-3/4 xl:w-2/3 gap-10"}>
                <a href={"#About"} aria-label={"Go on About"} className={"arrow fade"}>
                    <SvgArrow className={"w-5"} color={defaultTheme.theme.colors.third}/>
                </a>
                <div className={"flex flex-col justify-center h-screen gap-3"}>
                    <p className={"font-light"}>Bonjour, Je suis</p>
                    <h1 className={"text-5xl md:text-7xl"}>Hugo GALAN.</h1>
                    <h1 className={"text-5xl md:text-7xl"}>Développeur.</h1>
                    <p className={"md:text-2xl"}>Transformez votre vision en réalité digitale avec un développeur
                        passionné et à l'écoute !
                    </p>
                </div>
                <div id={"About"} className={"flex flex-col justify-center min-h-screen"}>
                    <div className={"flex justify-between gap-5 mt-2"}>
                        <h1 className={"text-2xl lg:text-5xl reveal"}>A propos de moi</h1>
                        <div className={"flex flex-col justify-center w-1/3"}>
                            <hr className={"reveal"}/>
                        </div>
                    </div>
                    <div className={"flex flex-col-reverse md:flex-row justify-around mt-6 lg:mt-10 gap-14"}>
                        <div className={"flex flex-col gap-5 md:w-6/12 reveal"}>
                            <h3>
                                Bonjour, je m'appelle Hugo. J’ai {(new Date()).getFullYear() - 2004} ans, j'étudie à
                                Epitech et je suis passionné par les nouvelles technologies. J'aime explorer et
                                maîtriser ces innovations par moi-même.
                            </h3>
                            <h3>
                                En tant que développeur, je prends plaisir à résoudre des problèmes complexes et à
                                expérimenter de nouvelles approches pour m'améliorer continuellement. Je crois fermement
                                que l'apprentissage est un voyage sans fin et qu'il est crucial de rester à la pointe
                                des technologies avancées pour demeurer performant dans mon domaine.
                            </h3>
                            <h3>
                                Pour preuve, en plus de mon Master à Epitech en ingénierie logicielle et innovation,
                                j'ai entrepris en quatrième année un deuxième Master en intelligence artificielle à
                                l'université de Kent, afin d'acquérir une double expertise.
                            </h3>
                            <h3>
                                J'apprécie particulièrement le travail en équipe et je suis toujours à l'écoute des
                                idées de mes collaborateurs. Ma curiosité insatiable me pousse constamment à apprendre
                                et à m'adapter.
                            </h3>
                            <h3>
                                Si vous avez des projets à réaliser, je serais ravi d'en discuter avec vous. N'hésitez
                                pas à me <a href={"#Contact"}>contacter</a> pour découvrir comment je peux vous aider à
                                concrétiser vos idées en matière de développement.
                            </h3>
                        </div>
                        <div className={"flex justify-center"}>
                            <div className={"img w-8/12 md:w-full max-h-72 aspect-square reveal"}>
                                <img alt={"Hugo GALAN"} src={imgMe} className={"rounded"}></img>
                            </div>
                        </div>
                    </div>
                </div>
                <div id={"Work"} className={"flex flex-col justify-center min-h-screen"}>
                    <div className={"flex justify-between gap-5 mt-2"}>
                        <h1 className={"text-2xl lg:text-5xl reveal"}>Work</h1>
                        <div className={"flex flex-col justify-center w-1/3"}>
                            <hr className={"reveal"}/>
                        </div>
                    </div>
                    <div className={"flex flex-wrap justify-around gap-5 mt-6 lg:mt-10"}>
                        {Works.map((e, i) => <CardWork key={i} images={e.images} alts={e.alts} title={e.title}
                                                       description={e.description} github={e?.github}
                                                       siteLink={e?.link}/>)}
                    </div>
                </div>
                <div id={"Contact"} className={"flex flex-col justify-center min-h-screen h-screen"}>
                    <div className={"flex justify-between gap-5 mt-2"}>
                        <h1 className={"text-2xl lg:text-5xl reveal"}>Contact</h1>
                        <div className={"flex flex-col justify-center w-1/3"}>
                            <hr className={"reveal"}/>
                        </div>
                    </div>
                    <div className={"flex flex-col justify-center items-center gap-5 mt-6 lg:mt-10 h-1/2"}>
                        <div className={"flex w-full md:w-2/3 flex-col justify-center gap-5 reveal"}>
                            <h3 className={"text-center"}>
                                Vous avez un projet en tête ? Vous avez besoin d'un développeur pour vous aider à
                                le réaliser ? N'hésitez pas à me contacter !
                            </h3>
                        </div>
                        <div
                            className={"flex flex-row justify-center flex-wrap items-center w-full md:w-2/3 reveal"}>
                            <div className={"flex flex-col justify-center items-center gap-2 mt-10 w-1/2"}>
                                <a href={"mailto:hugo.galan8@gmail.com"} aria-label={"Send me a mail"}>
                                    <SvgMail className={"w-10"} color={defaultTheme.theme.colors.third}/>
                                </a>
                                <p className={"text-center"}>
                                    hugo.galan8@gmail.com
                                </p>
                            </div>
                            <div className={"flex flex-col justify-center items-center gap-2 mt-10 w-1/2"}>
                                <a href={"https://www.linkedin.com/in/hugo-galan-259743287/"}
                                   aria-label={"Go on my linkedin"} target={"_blank"}
                                   rel={"noreferrer"}>
                                    <SvgLinkedin className={"w-10"} color={defaultTheme.theme.colors.third}/>

                                </a>
                                <p className={"text-center"}>
                                    Hugo GALAN
                                </p>
                            </div>
                            <div className={"flex flex-col justify-center items-center gap-2 mt-10 w-1/2"}>
                                <a href={"https://github.com/HForGames"} aria-label={"Go on my github"}
                                   target={"_blank"} rel={"noreferrer"}>
                                    <SvgGithub className={"w-10"} color={defaultTheme.theme.colors.third}/>
                                </a>
                                <p className={"text-center"}>
                                    HForGames
                                </p>
                            </div>
                            <div className={"flex flex-col justify-center items-center gap-2 mt-10 w-1/2"}>
                                <a href={"tel:+336 78 73 90 81"} aria-label={"Call me"}>
                                    <SvgPhone className={"w-10"} color={defaultTheme.theme.colors.third}/>
                                </a>
                                <p className={"text-center"}>
                                    +336 78 73 90 81
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default App;
